import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import _ from "lodash";
import Schemas from "schemas";

import styled from "styled-components";

import UserApi from "../../api/user-api";
import OECDs from "../../constants/OECDs.json";

import { Control } from "components/ui-kit/control";
import { AuthStyles, Button, PhotoDropzone } from "components/ui-kit/styled-templates";

import useFormControl from "hooks/useFormControl";
import { useStorageListener } from "hooks/useStorage";

import { EForms } from "types/enums";
import StudentProfileIntoPage from "./student-profile-info-page";
import Tabs from "../ui/Tabs";
import AmbassadorSettingsPanel from "../ambassadors/panels/AmbassadorSettingsPanel";

const WrappedStudentProfileIntoPage = () => {
    const { t } = useTranslation();

    const uData = useStorageListener("user", {});
    const { data, onSubmit, setValues } = useFormControl({
        name: EForms.studentProfileInfo,
        schema: Schemas.studentProfileInfo
    });
    const handlers = {
        submit: async (details) => {
            console.log("details = ", details);
            await UserApi.updateUser({ id: uData.id, ...details });
            window.alert(t("ea2f8og5y3m"));
            // await UniversityApi.updateMyUniversity({ id, details });
            // navigate(`/`);
        }
    };

    useEffect(
        () =>
            setValues(
                _.pick(uData, [
                    "email",
                    "firstName",
                    "lastName",
                    "middleName",
                    "gender",
                    "departureCity",
                    "phone",
                    "socialUrl",
                    "universityName",
                    "avatar",
                    "birthday",
                    "WoS",
                    "WoS1",
                    "studentRoleType"
                ])
            ),
        [uData]
    );

    console.log("EForms.studentProfileInfo = ", EForms.studentProfileInfo);
    console.log("EForms.uData = ", uData);
    let isAmbassador = (uData?.isAmbassador == true);
    if (uData?.ambassadorExpirationTimestamp != undefined && +uData?.ambassadorExpirationTimestamp < +new Date()) {
        isAmbassador = false;
    }

    return (
        <AuthStyles.Container
            extra={`padding-left: 304px; padding-right: 304px; margin-bottom: 30px; border: none; background: none;`}>

            <Wrapper>
                <Tabs
                    tabs={[
                        {
                            label: "Настройка профиля",
                            content: (
                                <div>
                                    <StudentProfileIntoPage />
                                </div>
                            )
                        },
                        (isAmbassador == false) ? null :
                            {
                                label: "Амбассадор",
                                content: (
                                    <div>
                                        <AmbassadorSettingsPanel />
                                    </div>
                                )
                            }
                    ].filter(x => (x != undefined))}
                />
            </Wrapper>


        </AuthStyles.Container>
    );
};

export default WrappedStudentProfileIntoPage;

const Wrapper = styled.div`
  @media (max-width: 820px) {
    margin-top: 50px;
  }
`;